import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import BecauseTrustDeservesVerification from "./sections/BecauseTrustDeservesVerification";
import PreservingDignity from "./sections/PreservingDignity";
import ModernCouple from "./sections/ModernCouple";
import TheJourneyToClarity from "./sections/TheJourneyToClarity";
import OurAreasOfExpertise from "./sections/OurAreasOfExpertise";
import FoundationsOfTrust from "./sections/FoundationsOfTrust";
import TrustedByFamiliesAndProfessionals from "./sections/TrustedByFamiliesAndProfessionals";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <BecauseTrustDeservesVerification />
      <PreservingDignity />
      <ModernCouple />
      <TheJourneyToClarity />
      <OurAreasOfExpertise />
      <FoundationsOfTrust />
      <TrustedByFamiliesAndProfessionals />
      <Footer />
    </div>;
}